// src/services/inventoryService.js
import { authenticatedFetch, handleApiError } from './api';
import api from './api';

const API_URL = '/inventory';

const getAllItems = () => {
 return authenticatedFetch(API_URL).catch(handleApiError);
};

const getItemById = (id) => {
 return authenticatedFetch(`${API_URL}/${id}`).catch(handleApiError);
};

const getItemHistory = (id) => {
 return authenticatedFetch(`${API_URL}/${id}/history`).catch(handleApiError);
};

// --- NEW FUNCTION ---
// Get the complete inventory history log for all items
const getCompleteHistory = () => {
 return authenticatedFetch(`${API_URL}/history`).catch(handleApiError);
};
// --- END NEW FUNCTION ---

const importFromCSV = (formData) => {
 return authenticatedFetch(`${API_URL}/import`, {
 	method: 'POST',
 	body: formData,
 }, true);
};

const createItem = (itemData) => {
 return authenticatedFetch(API_URL, {
 	method: 'POST',
 	body: JSON.stringify(itemData),
 }).catch(handleApiError);
};

const updateItem = (id, itemData) => {
 return authenticatedFetch(`${API_URL}/${id}`, {
 	method: 'PUT',
 	body: JSON.stringify(itemData),
 }).catch(handleApiError);
};

const deleteItem = (id) => {
 return authenticatedFetch(`${API_URL}/${id}`, {
 	method: 'DELETE',
 }).catch(handleApiError);
};

const getLowStockAlerts = () => {
  return authenticatedFetch(`${API_URL}/alerts/low-stock`).catch(handleApiError);
};

const dismissLowStockAlert = (alertId) => {
  return authenticatedFetch(`${API_URL}/alerts/low-stock/${alertId}/dismiss`, {
    method: 'PUT',
  }).catch(handleApiError);
};

const getValuation = () => {
 return authenticatedFetch(`${API_URL}/valuation`).catch(handleApiError);
};

const generateItemDetails = async (itemName, category) => {
  try {
    const response = await api.post('/inventory/ai/generate-details', { itemName, category });
    return response.data;
  } catch (error) {
    console.error("Error generating item details via AI:", error);
    throw error;
  }
};

// --- ADDED FUNCTION ---

// --- END ADDED FUNCTION ---

const inventoryService = {
 getAllItems,
 getItemById,
 getItemHistory,
 getCompleteHistory, // Ensure it's exported
 importFromCSV,
 createItem,
 updateItem,
 deleteItem,
 getLowStockAlerts,
 dismissLowStockAlert,
 getValuation, // Ensure it's exported
 generateItemDetails,
};

export default inventoryService;